import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import noImage from "../../../src/no_Image.jpg";
import { useSelector, useDispatch } from "react-redux";
import "../../index.css";
import {
  setSelectedPoE,
  setFinalData,
  deletePoe,
  updateSwitch2,
  updateComparisonData,
} from "../../app/features/counter/counterSlice";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
// Universal Data (Category CSV)
import { ProductCsvData } from "../fetchData/ProductCsvData.js";
import { ProductOptionsCsvData } from "../fetchData/ProductOptionsCsvData.js";
import DisplayDrops from "./DisplayDrops.js";
import WarningComponent from "./WarningComponent.js";
import { calculateLineItem, getOptionEntries, getProductSku, getProductDisplayName } from "./quoteCalculator";

// Modal-1 Starts
function MyVerticallyCenteredModal({
  show,
  dataForProduct,
  onHide,
  showButtons,
  productOptionCSVQuery,
}) {
  const dispatch = useDispatch();
  const [count, setCount] = useState(1);
  const [poeFinalPrice, setPoeFinalPrice] = useState(
    showButtons === "edit" ? dataForProduct.existingPrice : dataForProduct.price
  );
  const [unitCostInput, setUnitCostInput] = useState("");
  const [mergedState, setMergedState] = useState({});
  const [finalDatas, setFinalDatas] = useState([]);
  const [selectedOptionFields, setSelectedOptionFields] = useState({});

  const getPoeCalc = (quantity = count, unitPrice = poeFinalPrice, optionFields = selectedOptionFields) =>
    calculateLineItem({
      pricePerItem: Number(unitPrice || 0),
      quantity: Number(quantity || 0),
      ...optionFields,
    });

  const whichOption = useSelector(
    (state) => state.counter1.whichOptionSelected
  );

  const buildOptionGroups = (productId) => {
    const result = [];
    let currentArray = [];

    for (let i = 0; i < (productOptionCSVQuery || []).length; i += 1) {
      const option = productOptionCSVQuery[i];

      if (
        option.productid === productId ||
        (currentArray.length > 0 && option.productid === "")
      ) {
        currentArray.push(option);
      } else if (currentArray.length > 0) {
        result.push([...currentArray]);
        currentArray = [];
      }
    }

    if (currentArray.length > 0) {
      result.push([...currentArray]);
    }

    return result;
  };

  const handleOptionChange = (e) => {
    const { name, value } = e.target;
    const selectedOption = finalDatas
      .flat()
      .find(
        (option) =>
          option.featurecaption === name && option.featurename === value
      );

    const optionPrice = selectedOption
      ? parseFloat(selectedOption.featureprice) || 0
      : 0;

    setSelectedOptionFields((prev) => ({
      ...prev,
      [name]: value,
      [`${name}_price`]: optionPrice,
    }));
  };

  useEffect(() => {
    const calc = getPoeCalc();

    const newState = {
      num_options: whichOption,
      Port_Name: dataForProduct.id,
      Port_Base_Price: dataForProduct.price,
      Port_Quantity: count,
      quantity: calc.quantity,
      Extra_Field: dataForProduct.extra_field_3,
      poeFinalPrice: calc.unitPrice,
      pricePerItem: calc.unitPrice,
      totalPriceForItem: calc.unitTotal,
      Product_Final_Price: calc.lineTotal,
      thumbnail: dataForProduct.thumb,
      image1: dataForProduct.img1,
      image2: dataForProduct.img2,
      image4: dataForProduct.img3,
      myUnitPrice: 10,
      description: dataForProduct.desc,
      name: dataForProduct.name,
      ...selectedOptionFields,
    };

    if (dataForProduct.drop) {
      newState.drop = dataForProduct.drop;
    }

    setMergedState(newState);
  }, [count, poeFinalPrice, whichOption, dataForProduct, selectedOptionFields]);

  useEffect(() => {
    if (show) {
      const optionGroups = buildOptionGroups(dataForProduct.id);
      setFinalDatas(optionGroups);

      const initialOptions = {};
      optionGroups.forEach((group) => {
        if (group[0] && group[0].featurecaption) {
          const savedValue = dataForProduct[group[0].featurecaption];
          const savedPrice = dataForProduct[`${group[0].featurecaption}_price`];

          initialOptions[group[0].featurecaption] =
            savedValue || group[0].featurename;
          initialOptions[`${group[0].featurecaption}_price`] =
            savedPrice !== undefined
              ? Number(savedPrice || 0)
              : parseFloat(group[0].featureprice) || 0;
        }
      });
      setSelectedOptionFields(initialOptions);

      if (showButtons === "edit") {
        setCount(dataForProduct.existingQuantity);
        setPoeFinalPrice(parseFloat(dataForProduct.existingPrice));
      } else {
        setCount(1);
        setPoeFinalPrice(parseFloat(dataForProduct.price));
      }
    }
  }, [show, showButtons, dataForProduct, productOptionCSVQuery]);

  const addSwitchesQuantity = () => {
    const finalState = {
      ...mergedState,
      uniqueID:
        Date.now().toString(36) + Math.random().toString(36).substr(2, 5),
    };
    dispatch(setSelectedPoE(finalState));
    dispatch(setFinalData(finalState));
    onHide();
  };
  const updateSwitch = () => {
    const calc = getPoeCalc();
    const updatedItem = {
      ...mergedState,
      uniqueID: dataForProduct.uniqueID,  
      Port_Quantity: count,
      quantity: calc.quantity,
      poeFinalPrice: calc.unitPrice,
      pricePerItem: calc.unitPrice,
      totalPriceForItem: calc.unitTotal,
      Product_Final_Price: calc.lineTotal,
      Port_Base_Price: dataForProduct.price,
      ...selectedOptionFields,
    };
    dispatch(updateSwitch2(updatedItem));
    onHide();
  };

  const resetForm = () => {
    setCount(1);
    setPoeFinalPrice(0);
    setFinalDatas([]);
    setSelectedOptionFields({});
  };

  useEffect(() => {
    if (!show) {
      resetForm();
    }
  }, [show]);

  const handlePlusClick = () => setCount(count + 1);
  const handleMinusClick = () => count > 1 && setCount(count - 1);
  const handlePlusClickByFive = () => setCount(count + 5);
  const handleMinusClickByFive = () => count > 5 && setCount(count - 5);
  const handlePlusClickByTen = () => setCount(count + 10);
  const handleMinusClickByTen = () => count > 10 && setCount(count - 10);

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (/^\d*(\.\d{0,2})?$/.test(value)) {
      setUnitCostInput(value);
      const numericValue = value === "" || value === "." ? 0 : parseFloat(value);
      setPoeFinalPrice(isNaN(numericValue) ? 0 : numericValue);
    }
  };

  const typedDecrement = () => {
    setUnitCostInput("");
    setPoeFinalPrice((prev) => {
      const newValue = parseFloat((prev - 1).toFixed(2));
      return isNaN(newValue) ? 0 : newValue;
    });
  };

  const typedIncrement = () => {
    setUnitCostInput("");
    setPoeFinalPrice((prev) => {
      const newValue = parseFloat((prev + 1).toFixed(2));
      return isNaN(newValue) ? 0 : newValue;
    });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Switch : {dataForProduct.id}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col md={4}>
              <Row>
                <Card.Img
                  variant="top"
                  style={{
                    objectFit: "cover",
                    width: "300px",
                    height: "auto",
                    margin: "0 auto",
                  }}
                  // src={
                  //   "https://platinumcctv.com/" + dataForProduct.thumb ||
                  //   "path/to/noImage.png"
                  // }
                  src={
                    dataForProduct.thumb === ""
                      ? "https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png"
                      : "https://platinumcctv.com/" + dataForProduct.thumb
                  }
                />
              </Row>
              <Row className="my-2">
                {["img1", "img2", "img3"].map((img, index) => (
                  <Col key={index}>
                    <Card.Img
                      variant="top"
                      height={50}
                      // src={"https://platinumcctv.com/" + dataForProduct[img]}
                      src={
                        dataForProduct[img] === ""
                          ? "https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png"
                          : "https://platinumcctv.com/" + dataForProduct[img]
                      }
                    />
                  </Col>
                ))}
              </Row>
            </Col>

            <Col md={8}>
              <p>
                Product Description:
                {dataForProduct.desc || <em>{dataForProduct.category}</em>}
              </p>
              {finalDatas.map((group, index) => (
                <React.Fragment key={group[0]?.featurecaption || index}>
                  <Form.Label>{group[0]?.featurecaption}</Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    className="mb-3"
                    name={group[0]?.featurecaption}
                    value={selectedOptionFields[group[0]?.featurecaption] || ""}
                    onChange={handleOptionChange}
                  >
                    {group.map((option, optionIndex) => (
                      <option key={optionIndex} value={option.featurename}>
                        {option.featurename + " $ " + option.featureprice}
                      </option>
                    ))}
                  </Form.Select>
                </React.Fragment>
              ))}

              <div className="d-flex align-items-end justify-content-around my-4">
                Qty:
                <Button variant="dark" onClick={handleMinusClickByTen}>
                  -10
                </Button>
                <Button variant="dark" onClick={handleMinusClickByFive}>
                  -5
                </Button>
                <Button variant="dark" onClick={handleMinusClick}>
                  -
                </Button>
                <h6 className="mx-3">{count}</h6>
                <Button variant="dark" onClick={handlePlusClick}>
                  +
                </Button>
                <Button variant="dark" onClick={handlePlusClickByFive}>
                  +5
                </Button>
                <Button variant="dark" onClick={handlePlusClickByTen}>
                  +10
                </Button>
              </div>
              <div className="d-flex align-items-center justify-content-end">
                Unit Cost:
                <InputGroup className="mb-3">
                  <Button
                    variant="dark"
                    className="mx-3"
                    onClick={typedDecrement}
                  >
                    -
                  </Button>
                  <Form.Control
                    type="number"
                    step="0.01" // This allows decimal values with 2 decimal places
                    value={unitCostInput !== "" ? unitCostInput : (poeFinalPrice || 0)}
                    onFocus={() => setUnitCostInput(String(poeFinalPrice ?? ""))}
                    onBlur={() => setUnitCostInput("")}
                    onChange={handleInputChange}
                  />
                  <Button
                    variant="dark"
                    className="mx-3"
                    onClick={typedIncrement}
                  >
                    +
                  </Button>
                </InputGroup>
              </div>
              <div className="mt-4">
                <h5 className="text-end">
                  <strong>
                    Total: $
                    {getPoeCalc().lineTotal.toFixed(2).replace(/\.?0+$/, "")}
                  </strong>
                </h5>
              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between">
        <Button variant="dark" onClick={onHide}>
          Back
        </Button>
        {showButtons === "edit" ? (
          <Button variant="dark" onClick={updateSwitch}>
            Update Switch
          </Button>
        ) : (
          <Button variant="dark" onClick={addSwitchesQuantity}>
            Add
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}

function PoeSwitches() {
  // UniverSal Data Starts
  const { productCSVQuery } = ProductCsvData();
  const { productOptionCSVQuery } = ProductOptionsCsvData();
  // UniverSal Data Ends
  const areYouDealer = useSelector((state) => state.counter1.areYouDealer);

  const selectedCameraQuantity = useSelector(
    (state) => state.counter1.selectedCameraQuantity
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  // Modal state-1
  const [modalShow, setModalShow] = React.useState(false);
  // Modal state-2
  const [modalShow2, setModalShow2] = React.useState(false);
  // Set dataForProduct
  const [dataForProduct, setDataForProduct] = useState([]);
  //product option csv

  // Redux State
  const selectedCameraNumber = useSelector(
    (state) => state.counter1.totalCamera
  ); // Showing Camera Number Data

  const totalNoOptions = useSelector((state) => state.counter1.totalNoOptions);
  const [totalDrops, setTotalDrops] = useState(0);

  const [showButtons, setShowButtons] = useState(null);
  const [showWarningComponent, setShowWarningComponent] = useState(false);

  // Modal-2 Open
  function handleButtonClick2(e) {
    if (selectedCameraNumber > totalPoEPortCount) {
      setModalShow2(true);
    } else {
      navigate("/special");
    }
  }

  const poeSwitchData = productCSVQuery
    ? productCSVQuery
        .filter((item) => {
          if (item.categories) {
            const categoriesWords = item.categories.split("/");

            if (areYouDealer === "Dealer Selected") {
              if (item.hide_2 === "0") {
                return categoriesWords.some((word) => word === "PoE Switches");
              }
            } else if (areYouDealer !== "Dealer Selected") {
              if (item.hide_1 === "0") {
                return categoriesWords.some((word) => word === "PoE Switches");
              }
            }
          }
          return false;
        })
        .sort((a, b) => parseInt(a.sorting) - parseInt(b.sorting))
    : [];

  // Modal-1 Open
  function handleButtonClick(e, val, type) {
    setShowButtons(type);
    setModalShow(true);

    // Common properties for both modes
    let newState = {
      id: type === "edit" ? val.Port_Name : val.id,
      desc: val.description || val.desc || "",
      name: val.name,
      category: val.categories || val.category || "",
      uniqueID: type === "edit" ? val.uniqueID : null,
      // Initialize with existing values if editing
      existingQuantity: type === "edit" ? val.Port_Quantity : 1,
      existingPrice:
        type === "edit"
          ? val.poeFinalPrice
          : areYouDealer !== "Dealer Selected"
          ? val.price
          : val.price_2,
    };

    if (type === "edit") {
      Object.keys(val || {}).forEach((key) => {
        if (
          ![
            "num_options",
            "Port_Name",
            "Port_Base_Price",
            "Port_Quantity",
            "Extra_Field",
            "poeFinalPrice",
            "thumbnail",
            "image1",
            "image2",
            "image4",
            "myUnitPrice",
            "description",
            "name",
            "drop",
            "uniqueID",
          ].includes(key)
        ) {
          newState[key] = val[key];
        }
      });
    }

    // Handle image paths
    if (type === "edit") {
      // Edit mode - use the table data structure
      newState = {
        ...newState,
        thumb: val.thumbnail || val.Main_Img || "",
        img1: val.image1 || val.Img_1 || "",
        img2: val.image2 || val.Img_2 || "",
        img3: val.image3 || val.Img_3 || "",
        price: val.Port_Base_Price || 0,
        extra_field_3: val.Extra_Field || val.extra_field_3 || "",
      };
    } else {
      // Add mode - use the product data structure
      newState = {
        ...newState,
        thumb: val.thumbnail || "",
        img1: val.img1 || "",
        img2: val.img2 || "",
        img3: val.img3 || "",
        price: areYouDealer !== "Dealer Selected" ? val.price : val.price_2,
        extra_field_3: val.extra_field_3 || "",
      };
    }

    // Handle drop/extra_field_2 if present
    if (val.extra_field_2 || val.drop) {
      newState = {
        ...newState,
        drop: val.extra_field_2 ? val.extra_field_2 : val.drop,
      };
    }

    setDataForProduct(newState);
  }

  // Redux
  const selectedNvrDetails = useSelector((state) => state.counter1.selectedPoE); // Showing Switch Details Data

  const countCamera = useSelector((state) => state.counter1.selectedCamera);
  const tableData = selectedNvrDetails;

  //************************* Delete Camera ***************************//
  const deletePoeSwitches = (name, option, uniqueID) => {
    dispatch(deletePoe({ name, option, uniqueID }));
  };
  //************************* Delete Camera ***************************//

  const calculateTotalValues = () => {
    let totalValue = 0;
    let totalPoEPortCount = 0;

    for (const item of tableData) {
      totalValue += calculateLineItem(item).lineTotal;
      totalPoEPortCount += parseInt(item.Extra_Field, 10); // Sum up the PoE port counts (assuming Extra_Field contains the port count)
    }

    return { totalValue, totalPoEPortCount };
  };

  const { totalValue, totalPoEPortCount } = calculateTotalValues();

  const whichOption = useSelector(
    (state) => state.counter1.whichOptionSelected
  );
  //filter table data based on num_option selected
  const filterData = tableData.filter(
    (item) => item.num_options === whichOption
  );

  const totalSelectedCameras = useSelector((state) => {
    const cameras = state.counter1.selectedCamera;
    const filteredCameras = cameras.filter(
      (item) => item.num_options === whichOption
    );
    let total = 0;
    filteredCameras.forEach((item) => {
      if (item.Product_Quantity) {
        total += item.Product_Quantity;
      }
    });
    return total;
  });

  // React.useEffect(() => {
  //   let drops = 0;
  //
  //   filterData.forEach(item => {
  //     if (item.drop) {
  //       drops += item?.drop * item?.Port_Quantity
  //     }
  //     drops > 0 ? setTotalDrops(totalSelectedCameras + drops) : setTotalDrops(0)
  //   });
  // }, [filterData]);

  const [poePortsPerOption, setPoePortsPerOption] = useState(null);

  React.useEffect(() => {
    let totalPoePorts = 0;

    filterData.forEach((item) => {
      const portQuantity = Number(item?.Port_Quantity);
      const extraField = Number(item?.Extra_Field);

      if (!isNaN(portQuantity) && !isNaN(extraField)) {
        totalPoePorts += portQuantity * extraField;
      }
    });

    setPoePortsPerOption(totalPoePorts || 0);

    if (whichOption && totalNoOptions !== undefined) {
      dispatch(
        updateComparisonData({
          [whichOption]: {
            name: "poe",
            quantity: totalPoePorts || 0,
            warning: selectedCameraQuantity[whichOption] || 0,
            option: whichOption,
            navigationName: "/poe-switch",
          },
        })
      );
      // dispatch(updateComparisonData({ [whichOption]: { "name": 'poe', "quantity": 2, "warning": 3, "option": whichOption, "navigationName": "/poe-switch" } }))
    }
  }, [filterData]);

  return (
    <>
      <Container fluid className="my-4" style={{ backgroundColor: "" }}>
        <Container className="navbar_margin">
          <Row style={{ backgroundColor: "" }}>
            <Col style={{ backgroundColor: "" }} className="marginTopSpace">
              <h2>
                POEs Switches
                <span className="fst-italic fs-6">(Category)</span>
              </h2>
            </Col>
            {/* Right */}
            <Col className="marginTopSpace" style={{ backgroundColor: "" }}>
              <Row>
                <Col className="text-end">
                  Number of Cameras Required :
                  <span className="fw-bold">{selectedCameraNumber}</span>
                </Col>
              </Row>
              <Row>
                <Col className="text-end">
                  Total Cameras Selected:&nbsp;
                  <span className="fw-bold">{totalSelectedCameras}</span>
                </Col>
              </Row>
              <Row>
                <Col className="text-end">
                  Total POE Ports:&nbsp;
                  <span className="fw-bold">{poePortsPerOption}</span>
                </Col>
              </Row>
              <Row>
                <Col className="text-end">
                  <DisplayDrops />
                  {/* Total number of drops:&nbsp;
                  <span className="fw-bold">{filterData.length !== 0 ? totalDrops : 0}</span> */}
                </Col>
              </Row>
            </Col>
          </Row>

          {/* {filterData && filterData.length > 0 ? ( */}
          <Row className="" style={{ padding: "8px" }}>
            <Col>
              <h5 className="fw-bold">Add to Cart: </h5>

              <div className="table-border">
                <Table striped bordered hover responsive>
                  <colgroup>
                    <col style={{ width: "160px" }} />
                    <col style={{ width: "auto" }} />
                    <col style={{ width: "130px" }} />
                    <col style={{ width: "110px" }} />
                    <col style={{ width: "80px" }} />
                    <col style={{ width: "120px" }} />
                    <col style={{ width: "90px" }} />
                    <col style={{ width: "90px" }} />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>SKU: </th>
                      <th>Description & Options: </th>
                      <th>PoE Port: </th>
                      <th>Price: </th>
                      <th>QTY: </th>
                      <th>Total: </th>
                      <th colSpan={2} className="text-center">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {filterData.map((val, index) => {
                      const uniqueKey = `${val.Port_Name}-${index}`;
                      const calc = calculateLineItem(val);
                      const options = getOptionEntries(val, [
                        "Port_Name",
                        "Port_Base_Price",
                        "Port_Quantity",
                        "Extra_Field",
                        "poeFinalPrice",
                        "pricePerItem",
                        "totalPriceForItem",
                        "Product_Final_Price",
                        "myUnitPrice",
                        "cart_bucket",
                      ]);
                      return (
                        <tr key={uniqueKey}>
                          <td>{getProductSku(val)}</td>
                          <td>
                            <strong>{getProductDisplayName(val)}</strong>
                            {options.map((option) => (
                              <React.Fragment key={option.name}>
                                <br />
                                <strong>{option.name}:</strong> {option.value}{" "}
                                <strong>${Number(option.price || 0).toFixed(2)}</strong>
                              </React.Fragment>
                            ))}
                          </td>
                          <td>
                            {val.Extra_Field
                              ? val.Extra_Field * val.Port_Quantity
                              : 0}{" "}
                          </td>
                          <td>${calc.unitTotal.toFixed(2)}</td>
                          <td>{val.Port_Quantity}</td>
                          <td>${calc.lineTotal.toFixed(2)}</td>
                          <td>
                            <Button
                              key={val.id}
                              variant="dark"
                              className="mx-4"
                              onClick={(e) => {
                                handleButtonClick(e, val, "edit");
                              }}
                            >
                              Edit
                            </Button>
                          </td>
                          <td>
                            <Button
                              variant="dark"
                              onClick={() =>
                                deletePoeSwitches(
                                  val.Port_Name,
                                  val.num_options,
                                  val.uniqueID
                                )
                              }
                            >
                              Delete
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
          {/* ) : (
            ""
          )} */}

          <div className="d-flex justify-content-end align-items-center">
            {/* Show the warning to the before he moves to the next category */}
            {showWarningComponent ? (
              <WarningComponent
                path="/special"
                setShowWarningComponent={setShowWarningComponent}
              />
            ) : (
              ""
            )}
            <Button
              variant="dark"
              onClick={() => setShowWarningComponent(true)}
            >
              Next
            </Button>
          </div>

          {/* Box Row */}
          <Row className="my-4">
            {poeSwitchData.map((val, index) => {
              return (
                <Col
                  key={index}
                  md={4}
                  className="nvr_col my-2"
                  onClick={(e) => handleButtonClick(e, val, "add")}
                >
                  <Card style={{ width: "", margin: "" }}>
                    <Card.Body>
                      <Card.Title className="fw-bold">
                        SKU : {val.id}
                      </Card.Title>
                      <p className="category_para">{val.categories}</p>
                      <Card.Text>
                        {val.description ? (
                          val.description.split(" ").length > 13 ? (
                            `${val.description
                              .split(" ")
                              .slice(0, 13)
                              .join(" ")}...`
                          ) : (
                            val.description
                          )
                        ) : (
                          <span
                            style={{
                              whiteSpace: "pre-wrap",
                              display: "block",
                              minHeight: "2.5em",
                            }}
                          >
                            &nbsp;
                          </span>
                        )}
                      </Card.Text>

                      <Row
                        style={{
                          height: "185px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Col xs={8}>
                          <Card.Img
                            variant="top"
                            style={{
                              width: "100%",
                              height: "100%",
                              maxHeight: "200px",
                              objectFit: "contain",

                              // aspectRatio: "1",
                              border: "0px solid grey",
                            }}
                            src={
                              val.thumbnail === ""
                                ? "https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png"
                                : "https://platinumcctv.com/" + val.thumbnail
                            }
                          />
                        </Col>
                        <Col
                          xs={4}
                          className="d-flex align-items-center justify-content-center fw-bold"
                        >
                          ${" "}
                          {areYouDealer !== "Dealer Selected"
                            ? val.price
                            : val.price_2}
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>

          {/* Table */}

          {/* Button */}
          {/* <Row className="my-4" style={{ backgroundColor: "" }}>
            <Col className="d-flex justify-content-between">
              <Button
                className="poe_next_btn"
                variant="dark"
                onClick={(e) => handleButtonClick2(e)}
              >
                Next
              </Button>
            </Col>
          </Row> */}
        </Container>
      </Container>

      <MyVerticallyCenteredModal
        show={modalShow}
        dataForProduct={dataForProduct}
        onHide={() => setModalShow(false)}
        showButtons={showButtons}
        productOptionCSVQuery={productOptionCSVQuery}
      />
    </>
  );
}

export default PoeSwitches;
